import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import getFileUrl from 'core/application/commons/fileStorage/getFileUrl'
import { ExpenseAttachment } from 'core/application/docReviewDashboard/expenses/expenseAttachment'

import Modal from 'common/components/feedback/Modal'
import notification from 'common/components/feedback/Notification'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import { queryRequest } from 'common/RequestUtils'

interface ViewExpenseAttachmentProps {
  attachments: ExpenseAttachment[]
  visible: boolean
  onClose: () => void
}

const ViewExpenseAttachment: React.FC<ViewExpenseAttachmentProps> = ({ attachments, visible, onClose }) => {
  const { t: translate } = useTranslation()

  const getDocumentUrl = async (filename: string) => {
    const result = await queryRequest(() => getFileUrl(filename))
    if (!result.errors) {
      return result
    } else {
      notification.open({
        type: 'error',
        message: result.errors[0].message,
      })
      return ''
    }
  }

  const getAttachmentsContent = (): ReactNode => {
    return attachments.map((item, index) => {
      return (
        <a
          onClick={async (e) => {
            e.stopPropagation()
            const documentUrl = await getDocumentUrl(item.filename)
            if (documentUrl) window.open(documentUrl, '_blank')
          }}
          target="_blank"
        >
          <Icon type="far fa-paperclip" fontAwesome className="mr-8" />

          {item.title}
        </a>
      )
    })
  }

  const modalFooterActions = (
    <Button htmlType="button" onClick={onClose} type="default">
      {translate('general.cancel')}
    </Button>
  )

  return (
    <Modal
      title={translate('doc-review-dashboard.search-expenses.view-documents')}
      visible={visible}
      destroyOnClose
      closable
      onCancel={onClose}
      footer={modalFooterActions}
    >
      <div className="flex flex__direction_column">{getAttachmentsContent()}</div>
    </Modal>
  )
}

export default ViewExpenseAttachment
